module.exports = __webpack_public_path__ + "static/media/job_category_14.4cf73328.png";